
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","viewBox":"0 0 20 20","fill":"none","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.083 11.25l4.34-4.34a.832.832 0 00.244-.588V4.167a.834.834 0 00-.834-.834H4.167a.834.834 0 00-.834.834v2.155c0 .22.088.433.245.589l4.339 4.339M7.917 11.25v5.207c0 .678.636 1.175 1.294 1.011l2.083-.52c.463-.116.79-.533.79-1.011V11.25"}})])
          )
        }
      }
    